<template>
  <div class="focus-card" :style="cardStyle">
    <h4 class="focus-card__title">{{ title }}</h4>
    <p class="focus-card__subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "FocusCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    cardStyle() {
      const isOdd = this.index % 2 !== 0;
      return {
        backgroundColor: isOdd ? "#F3EEE5" : "#FBF8F3",
        border: "1px solid #DDD4C4",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.focus-card {
  border-radius: 16px;
  padding: 22px 22px 100px 22px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  &__title {
    font-family: $font-family;
    font-size: 28px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.18;
    margin: 0 0 12px 0;
    text-align: left;
    white-space: pre-line;
  }

  &__subtitle {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    color: #6a6256;
    line-height: 1.72;
    margin: 0;
    text-align: left;
  }

  @media (max-width: 767px) {
    &__title {
      font-size: 22px;
    }

    &__subtitle {
      font-size: 13px;
    }
  }
}
</style>
